import React, { Fragment, Component, useRef, useState, useEffect } from 'react'
import { accessRole } from "../../../../helpers/access_role"
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, 
    Button, Label, Input
} from "reactstrap"
import { Link } from "react-router-dom"
import YearSelect from "../../../../helpers/ui/YearSelect"

import apiResponse from '../../../../services/apiResponse'
import { cancelToken } from '../../../../services/adapters/kepegawaian/menuService'

import IndexBloc from '../Index/Blocs/IndexBloc'

import TableComponent from './Components/TableComponent'

const reformatDate = (date) => {
    const months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
    ];
    const d = new Date(date);
    let dt = d.getDate()
    if (dt < 10)
        dt = '0'+dt

    if (date) {
        return dt + " " + months[d.getMonth()] + " " + d.getFullYear();
    }

    return ''
};

class PrediksiView extends Component {

    indexBloc = new IndexBloc()

    constructor(props) {
        super(props)
        this.activeRef = React.createRef()
        this.inactiveRef = React.createRef()
        this.state = {
            dataForm: {},
            filter: null,
            year: new Date().getFullYear()
        }
    }

    handlerOnSubmit = () => {
        this.setState({
            filter: this.state.year
        })
    }
   
    reloadInactiveRef = () => this.inactiveRef.current.setTokenAPI()

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Card>
                        <CardBody>
                            <div className="float-end">
                                <Link to='/kepegawaian/pemberian_penghargaan.html' style={{ marginRight: 5 }}>
                                    <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                </Link>
                            </div>
                            <CardTitle>
                                Prediksi Penghargaan
                            </CardTitle>
                            <hr />
                            <Row className="mb-3">
                                <label
                                    htmlFor="gender"
                                    className="col-md-2 col-form-label"
                                >
                                    Periode Tahun
                                </label>
                                <Col md={3}>
                                    <YearSelect 
                                        isAvForm={false}
                                        onChange={opt => this.setState({ year: opt.value })}
                                    />
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col md={2} />
                                <Col md={10}>
                                    <Button 
                                        color="primary" 
                                        type="button"
                                        onClick={() => this.handlerOnSubmit()}
                                    >
                                        <i className="uil-search-alt"></i> Lihat Prediksi Penghargaan
                                    </Button>
                                </Col>
                            </Row>
                            <TableComponent ref={this.inactiveRef} handleInactiveSuccess={this.reloadInactiveRef} year={this.state.filter} />
                        </CardBody>
                    </Card>
                </Container>

            </Fragment>
        )
    }
}

export default PrediksiView;